import { IMovementScheduleFli } from '@modeso/types__aumico-lib-annualreport-be';

export interface IMovementScheduleFormArray {
    fli: IMovementScheduleFli;
}
